import { jsx, Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import "react-router";
import "@perxis-auto/shared";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../../../../features/favorite/model/index.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "../../../../features/favorite/model/slice.js";
import { useGetFavoriteVehicles } from "../../../../features/favorite/lib/useGetFavoriteVehicles.js";
import { LoadingContext, ThisProvider } from "../../../../shared/context/this.js";
import { Constructor } from "../../../../shared/ui/constructor/Constructor.js";
import { Link } from "../../../../shared/ui/link/Link.js";
const Page = memo(function Page2({ page, redirect, layout, widgets }) {
  const {
    options: { limit }
  } = useAppSelector(selectors.selectSlice);
  const offset = page * limit;
  const { data, isLoading: isLoadingQuery, isUninitialized: isUninitializedQuery } = useGetFavoriteVehicles({ offset });
  const vehicles = data == null ? void 0 : data.items;
  const isHidden = !vehicles;
  const isLoading = isLoadingQuery || isUninitializedQuery;
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingContext.Provider, { value: isLoading, children: Array.from(Array(limit)).map((_, index) => /* @__PURE__ */ jsx(Col, { xs: 24, sm: 12, md: 12, lg: 8, xl: 6, xxl: 6, children: /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets }) }, `${String(index)}`)) });
  }
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(Fragment, { children: vehicles.map((vehicle) => {
    var _a;
    return /* @__PURE__ */ jsx(Col, { xs: 24, sm: 12, md: 12, lg: 8, xl: 6, xxl: 6, children: /* @__PURE__ */ jsx(ThisProvider, { data: vehicle, isLoading, children: /* @__PURE__ */ jsx(
      Link,
      {
        ...redirect.options,
        to: redirect.to,
        params: {
          ...(_a = redirect.options) == null ? void 0 : _a.params,
          vehicleId: vehicle.id
        },
        children: /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets })
      }
    ) }, vehicle.id) }, vehicle.id);
  }) });
});
export {
  Page
};
